import { match } from 'ts-pattern';

import {
  DeviceAssignmentFilters,
  PatientCategoryFilterKey,
  PatientNoteFilters,
  PatientQuestionnaireFilterKey,
  PrismaAppUsageFilter,
  QuestionnaireStatusFilter,
  SharingStatusFilters,
  TeleSettingsFilters,
} from '@shared/constants/filters';
import { PatientFilterCategory } from '@shared/constants/PatientFilterCategory';
import { SortDirections } from '@shared/constants/SortDirections';
import { ChangePatientsSortingPayload } from '@shared/redux/actions/payloadTypes/patientActionPayloads';
import { FiltersState, SortState } from '@shared/redux/state/patients';

export const setDefaultValueForFiltersByKey = (
  filterKey: keyof FiltersState,
  filtersState: FiltersState,
): FiltersState =>
  match(filterKey)
    .with('deviceAssignmentFilter', () => ({
      ...filtersState,
      deviceAssignmentFilter: DeviceAssignmentFilters.Empty,
    }))
    .with('patientNoteFilter', () => ({
      ...filtersState,
      patientNoteFilter: PatientNoteFilters.Empty,
    }))
    .with('sharedByMeToTenant', () => ({
      ...filtersState,
      sharedByMeToTenant: '',
    }))
    .with('sharedToMeFromTenant', () => ({
      ...filtersState,
      sharedToMeFromTenant: '',
    }))
    .with('sharingStatusFilter', () => ({
      ...filtersState,
      sharingStatusFilter: SharingStatusFilters.Empty,
    }))
    .with('teleSettingsFilter', () => ({
      ...filtersState,
      teleSettingsFilter: TeleSettingsFilters.Empty,
    }))
    .with('usersInCharge', () => ({
      ...filtersState,
      usersInCharge: [],
    }))
    .with('medicalConditionId', () => ({
      ...filtersState,
      medicalConditionId: null,
    }))
    .with(PatientCategoryFilterKey, () => ({
      ...filtersState,
      patientCategory: PatientFilterCategory.All,
    }))
    .with('prismaAppUsageFilter', () => ({
      ...filtersState,
      prismaAppUsageFilter: PrismaAppUsageFilter.Empty,
    }))
    .with(PatientQuestionnaireFilterKey, () => ({
      ...filtersState,
      questionnaireName: 'All',
    }))
    .with('questionnaireStatus', () => ({
      ...filtersState,
      questionnaireStatus: QuestionnaireStatusFilter.All,
    }))
    .exhaustive();

export const getSortingState = (state: SortState, payload: ChangePatientsSortingPayload) => {
  let direction = SortDirections.Descending;

  if (payload.defaultSortDirection != undefined) {
    direction = payload.defaultSortDirection;
  } else if (state.field === payload.field) {
    if (state.direction == SortDirections.Descending) {
      direction = SortDirections.Ascending;
    } else {
      direction = SortDirections.Descending;
    }
  }

  return {
    field: payload.field,
    direction,
  };
};
